import React, { Component, Fragment } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Button, GreyButton } from "Shared/Buttons";
// import Chat from "src/components/icons/Chat";
import Phone from "src/components/icons/Phone";
import styled from "styled-components";
import { formatDateForDisplay } from "../ScheduleAppointmentSuccess/lib";
import "./EditAppointment.scss";
import { appointmentIsExpired, getAppointmentTimeToDisplay } from "./lib";

const EditButton = styled(GreyButton)`
    margin-top: 18px;
    width: auto;
`;

class EditAppointment extends Component<any & WithTranslation> {
    public render() {
        const { t } = this.props;
        const formattedDate = this.props.selectedDate ? formatDateForDisplay(this.props.selectedDate) : "";
        const isExpired = appointmentIsExpired(this.props.selectedDate);

        return (
            <div className="EditAppointment">
                {isExpired ? this.getExpiredContent(formattedDate) : this.getScheduledContent(formattedDate)}
                <div className="EditAppointment__editButtonContainer">
                    <EditButton onClick={this.resetAppointment}>
                        {isExpired
                            ? t("ContinueDeal.EditAppointment.rescheduleAppointment")
                            : t("ContinueDeal.EditAppointment.editAppointment")}
                    </EditButton>
                </div>
                <div className="EditAppointment__additionalText">
                    {t("ContinueDeal.EditAppointment.additionalText", { model: this.props.vehicle.model })}
                </div>
                <div className="EditAppointment__cta">
                    {/* <Button
                        onClick={this.chatWithUs}
                    >
                        <Chat />&nbsp;Chat With Us
                    </Button> */}
                    {this.props.dealerPhone && (
                        <Button onClick={this.callUs}>
                            <Phone />
                            &nbsp;
                            {this.props.dealerPhone}
                        </Button>
                    )}
                </div>
            </div>
        );
    }

    private resetAppointment = () => {
        this.props.resetAppointment();
    };

    /*     private chatWithUs = () => {
        // TODO: Conversations
    }; */

    private callUs = () => {
        // TODO: Call?
    };

    private getExpiredContent = (formattedDate: string) => {
        const { t } = this.props;
        return (
            <Fragment>
                <strong>{t("ContinueDeal.EditAppointment.expiredContentTitle")}</strong>
                <br />
                {t("ContinueDeal.EditAppointment.expiredContentText", { formattedDate })}
            </Fragment>
        );
    };

    private getScheduledContent = (formattedDate: string) => {
        const { t } = this.props;
        return (
            <Fragment>
                <strong style={{ display: "inline-block", margin: "5px 0 10px" }}>
                    {t("ContinueDeal.EditAppointment.scheduledContentTitle")}
                </strong>
                <br />
                {t("ContinueDeal.EditAppointment.scheduledContentText", {
                    formattedDate,
                    selectedTime: getAppointmentTimeToDisplay(this.props.selectedTime),
                })}
            </Fragment>
        );
    };
}

export default withTranslation()(EditAppointment);
